import { Container, Title, Text, Button, Stack } from '@mantine/core';
import { useLineLogin } from '../hooks/useLineLogin';
import { nanoid } from 'nanoid';

interface LineLoginConfig {
  clientId: string;
  redirectUri: string;
  state: string;
}

interface LoginProps {
  userType: 'staff' | 'admin';
}

export function Login({ userType }: LoginProps) {
  const { handleLogin } = useLineLogin();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const state = {
      nonce: nanoid(),
      userType
    };
    const config: LineLoginConfig = {
      clientId: import.meta.env.VITE_LINE_CLIENT_ID,
      redirectUri: import.meta.env.VITE_LINE_REDIRECT_URI,
      state: JSON.stringify(state)
    };
    handleLogin(config);
  };

  return (
    <Container size="sm" py="xl">
      <Stack gap="xl">
        <Title order={1}>
          {userType === 'admin' ? '管理者ログイン' : 'Interval - シフト管理'}
        </Title>
        <Text>LINEアカウントでログインしてください</Text>
        <Button onClick={handleClick} size="lg">
          LINEでログイン
        </Button>
      </Stack>
    </Container>
  );
} 